/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Cargo Icon component.
 */
export const AssetCargoIcon = (props: IconProps) => {
  const {stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='AssetCargoIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M7.083 6h9.695a1.08 1.08 0 011.092 1.068v1.723h-.009v6.273a1.08 1.08 0 01-.941 1.055v.013a.989.989 0 01-.133.015h-4.629l-.03-.078a1.76 1.76 0 00-3.319 0l-.027.078H7.083A1.083 1.083 0 016 15.064V7.08A1.08 1.08 0 017.083 6z'
          fillRule='evenodd'
          clipRule='evenodd'
          fill={iconColor}
          stroke={stroke} />
        <path d='M10.484 18a1.313 1.313 0 100-2.625 1.313 1.313 0 000 2.625z'
          fill={iconColor}
          stroke={stroke} />
      </svg>
    )} />
  );
};
AssetCargoIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
